import { VisibilityOutlined, ConfirmationNumber, Anchor, Assignment, Timeline } from "@mui/icons-material";
import { Box, IconButton, Stack, TextField, Typography } from "@mui/material";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import { useNavigation } from "@refinedev/core";
import { useDataGrid } from "@refinedev/mui";
import { AdminOrderDto, OrderDto } from "../../apiClient/generated";
import { RefineListView } from "../../components/refine-list-view";
import { OrdersIcon } from "../../components/icons/orders-icon";
import { useSingleFieldSearch } from "../../hooks/useSingleFieldSearch";
import { orderStatusParser } from "../../lib/orderStatusParser";

export const ListOrders = () => {
  const { dataGridProps, setFilters } = useDataGrid<OrderDto>({
    syncWithLocation: true,
    filters: { mode: "server" },
    sorters: { mode: "server" },
    pagination: { mode: "server", pageSize: 10 },
    resource: "AdminOrders",
  });

  const columns: GridColDef<AdminOrderDto>[] = [
    {
      field: "wbPono",
      headerName: "wbPono",
      minWidth: 120,
      flex: 1,
      renderHeader: () => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <ConfirmationNumber fontSize="small" />
          wbPono
        </Box>
      ),
      renderCell: ({ row: order }) => order.wbPono,
    },
    {
      field: "vesselImo",
      headerName: "Vessel IMO",
      minWidth: 120,
      flex: 1,
      renderHeader: () => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Anchor fontSize="small" />
          Vessel IMO
        </Box>
      )
    },
    {
      field: "type",
      headerName: "Type",
      flex: 1,
      minWidth: 120,
      renderHeader: () => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Assignment fontSize="small" />
          Type
        </Box>
      ),
      renderCell: ({ row: order }) => `${order.type}`,
    },
    // { field: "systemRfqId", headerName: "System RFQ", minWidth: 100, flex: 1 },
    // { field: "status", headerName: "Status", flex: 1, renderCell: ({ row: order }) => `${order.statusText} (${order.status})`},
    // { field: "status_gateway", headerName: "Status (Gateway)", flex: 1, renderCell: ({ row: order }) => parseOrderStatus(order)},
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 200,
      renderHeader: () => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Timeline fontSize="small" />
          Status
        </Box>
      ),
      renderCell: ({ row: order }) => orderStatusParser(order).displayedStatus,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      hideable: false,
      filterable: false,
      disableColumnMenu: true,
      align: "center",
      headerAlign: "center",
      minWidth: 80,
      renderCell: function render({ row }) {
        return (
          <IconButton
            sx={{
              cursor: "pointer",
            }}
            onClick={() => edit("orders", row.orderId)}
          >
            <VisibilityOutlined color="action" />
          </IconButton>
        );
      },
    },
  ];

  const { edit } = useNavigation();

  const { searchValues, handleInputChange } = useSingleFieldSearch(
    {
      wbPono: "",
      vesselImo: "",
    },
    setFilters
  );

  const title = (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <OrdersIcon color="primary" />
      <Typography variant="h6">Orders</Typography>
    </Box>
  );

  return (
    <RefineListView title={title}>
      <Box mb={2}>
        <Stack direction="row" spacing={2} flexWrap="wrap">
          <TextField
            label="wbPono"
            value={searchValues.wbPono}
            onChange={handleInputChange("wbPono")}
            size="small"
          />
          <TextField
            label="Vessel IMO"
            value={searchValues.vesselImo}
            onChange={handleInputChange("vesselImo")}
            size="small"
          />
        </Stack>
      </Box>
      <DataGrid
        {...dataGridProps}
        columns={columns}
        getRowId={(row) => row.orderId}
        pageSizeOptions={[5, 10, 25, 50]}
        initialState={{
          density: "standard",
          columns: {
            columnVisibilityModel: {
              orderId: false,
            },
          },
        }}
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: false,
          },
        }}
        disableDensitySelector
        onRowClick={({ id }) => {
          edit("orders", id);
        }}
        sx={{
          "& .MuiDataGrid-row": {
            cursor: "pointer",
          },
        }}
      />
    </RefineListView>
  );
};
